// extracted by css-extract-rspack-plugin
var _1 = "tsrW3d0TQJYJ0k8I";
var _2 = "c4siFytWMZQZ6v_1";
var _3 = "c5FHOo_mqILJssoi";
var _4 = "c4siFytWMZQZ6v_1";
var _5 = "c5FHOo_mqILJssoi";
export { _1 as "vs", _2 as "vs-teams", _3 as "vs-teams-calendar", _4 as "vsTeams", _5 as "vsTeamsCalendar" }
